import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

const fromSentry = Symbol('fromSentry');

export function initSentry (app, router) {
  const sentry = Sentry.init({
    dsn: `${ window.location.protocol }//96570cb8e2084a17a95dd80f1c253e61@${ window.location.host }/sentry/10`,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        // tracingOrigins: [/\.smalldata\.app/],
      }),
    ],
    environment: window.location.origin,
    // debug: true,
    beforeSend (data, err) {
      console.error(err.originalException, fromSentry);
      return data;
    },
  });

  Sentry.setExtra('version', process.env.VERSION);
  Sentry.setExtra('branch', process.env.BRANCH);

  window.$sentry = sentry;
  return sentry;

  // Sentry.configureScope(function (scope) {
  //   scope.setTag('version', process.env.VERSION);
  //   scope.setTag('branch', process.env.BRANCH);
  // });
}
